import React, { useState } from 'react';
import './Advantages.css';

const TABS = [
  { id: 'advantages', label: 'Advantages of Zinga' },
  { id: 'vs-paint',   label: 'Zinga VS Paint' },
  { id: 'vs-hdg',     label: 'Zinga VS HDG' },
  { id: 'vs-metal',   label: 'Zinga VS Metallizing' },
  { id: 'vs-rebar',   label: 'Zinganised Re-bars VS FBEC' },
];

const ADVANTAGES = [
  {
    num: '01',
    title: 'Guaranteed 96% Zinc in Dry Film Thickness',
    body: 'ZINGA has a zinc content of 96% in the dry layer. The zinc is pure to 99.995%. In order to obtain a real cathodic protection you need at least 92% of zinc in the dry layer. That is scientifically proven. The so-called zinc-rich paints do not meet this condition.',
  },
  {
    num: '02',
    title: 'Ease of Application',
    body: 'Apply using a brush, roller or painting gloves. Can also be sprayed with a pistol, and it can be applied in a bath. Can be applied on site by non-professionals.',
  },
  {
    num: '03',
    title: 'Application Over a Wide Range of Weather Conditions',
    body: 'Can be applied over a damp surface (but not on drops of water). Humidity can even intensify the cathodic action and accelerate the formation of the zinc salts on the surfaces that offer the barrier protection. ZINGA can be applied at very high or low temperatures (up to 45°C or 113°F and down to -15°C or 5°F).',
  },
  {
    num: '04',
    title: 'Quick Drying Time',
    body: 'A new layer of ZINGA can be applied after 1 hour. Topcoats can be applied after 4 to 24 hours.',
  },
  {
    num: '05',
    title: 'No Cracking or Peeling',
    body: 'ZINGA does not peel off and is not brittle. In case of mechanical damage the ZINGA layer will be compressed or squashed, but it will not crack due to its flexibility.',
  },
  {
    num: '06',
    title: 'Rechargeability',
    body: 'Each new layer of ZINGA blends perfectly with the previous one. Additional layers all blend to one single, homogeneous ZINGA layer. There is no risk for accumulation of layers that are different in structure, which could cause peeling off.',
  },
  {
    num: '07',
    title: 'Weldable',
    body: 'Welding can be done over a layer of ZINGA without peeling or burning off the active cathodic layer. ZINGA can be simply applied over a welded layer and same corrosion protection properties will exist.',
  },
  {
    num: '08',
    title: 'Application over Metallised or Hot Dip Galvanised Structures',
    body: 'Structures that have been metallised or galvanised by hot-dip will begin to rust after a certain period. Such worn-out and damaged structures can also be recharged by ZINGA.',
  },
  {
    num: '09',
    title: 'Protection of Zinc with Specialized Binder',
    body: 'ZINGA is based on protected zinc. The zinc particles are protected by a special resin that allows the formation of the galvanic couple, but that also gives an additional protection. Therefore protection with ZINGA is a superior alternative for galvanisation by hot-dip.',
  },
  {
    num: '10',
    title: 'Atomised Zinc is the Best in the World',
    body: 'This atomisation process provides unique qualities and a very high zinc purity. This is also one of the reasons why ZINGA does not have one single true competitor in the world.',
  },
  {
    num: '11',
    title: 'Compatible as the Universal Primer',
    body: 'ZINGA can be topcoated by a large number of compatible paints. Such duplex systems will more than double the lifetime of ZINGA. Compatible paints include epoxy, polyurethane, vinyl and micaceous iron oxides (M.I.O.\'s). The lifetime of a duplex system is more than double the sum of the individual lifetimes.',
  },
  {
    num: '12',
    title: 'Non Toxic / Potable',
    body: 'ZINGA is composed of non-toxic elements according to European Standards and can be used in contact with potable water (BS 6920).',
  },
];

const VS_PAINT = [
  {
    characteristic: 'Active Cathodic Protection',
    zinga: 'ZINGA® offers real cathodic (galvanic) protection with 96% special zinc in its dry layer. Only ZINGA® with 92%+ zinc can rightly claim cathodic protection throughout the layer.',
    other: 'Not even paints with a relatively high zinc content can provide cathodic protection. Most zinc-rich paints have only a small percentage of zinc, which does not guarantee galvanising protection.',
  },
  {
    characteristic: 'Easy Application On Site',
    zinga: 'ZINGA® can be applied in the same way as paints — using a brush, roller or spraying (airless, conventional).',
    other: 'Paints can be applied on site using a brush, roller or spraying (airless, conventional).',
  },
  {
    characteristic: 'Reloadable',
    zinga: 'A cured ZINGA® layer will re-liquidise if a new layer of ZINGA® is applied, creating a single homogeneous layer with continuous electrochemical contact between zinc particles.',
    other: 'Apart from reversible paints (e.g. vinyl), most paints cannot be overcoated without creating two separate layers. If a painted structure needs repainting, the entire surface must be blast cleaned.',
  },
  {
    characteristic: 'Overcoatable',
    zinga: 'ZINGA® can be overcoated with a fast drying, compatible paint. Care should be taken to avoid affection of the zinc layer by aggressive solvents in the topcoat.',
    other: 'Protective paint systems mostly consist of 2 or 3 layers combining different types of paints to create a solid barrier layer and a decorative coloured finish.',
  },
  {
    characteristic: 'Application in Extreme Conditions',
    zinga: 'ZINGA® can be applied in a wide variety of weather conditions from -15°C to +40°C with a maximum humidity of 95%, as long as the dew point is 3°C above steel temperature.',
    other: 'Most paints have rather small windows of application for temperature, relative humidity and/or steel temperature. Only specialized (more expensive) paints can be used in less favorable conditions.',
  },
  {
    characteristic: 'Unlimited Shelf Life',
    zinga: 'ZINGA® has unlimited shelf life — it is possible to always have ZINGA® in storage for touch up or for future projects.',
    other: 'Most paints have a shelf life of between 1 and 3 years, preventing long storage for touch ups.',
  },
  {
    characteristic: 'Contact with Potable Water',
    zinga: 'ZINGA® only contains non-toxic elements in its dry layer. It can be used in contact with potable water. Wash the surface thoroughly with fresh water before use.',
    other: 'Only highly specialized paints can be used in contact with potable water. Most paints use xylene, toluene or M.E.K. solvents which cannot be used in contact with potable water.',
  },
  {
    characteristic: 'Flexible Layer',
    zinga: 'ZINGA® behaves like a metal when it comes to impact and bending. An impact will simply compress the zinc particles — not "breaking" the ZINGA® layer.',
    other: 'As the resin cures it becomes brittle. Upon impact, the resin shows cracks, creating a breach in the barrier protection.',
  },
  {
    characteristic: 'Welding on Coated Steel',
    zinga: 'Zinganised® steel can be welded without the release of any toxic fumes (tested according BS 6853) and with a very small burn back.',
    other: 'Steel coated with paint cannot be welded unless the paint is removed. Most paints release toxic fumes upon welding and leave an extensive burn back.',
  },
];

const VS_HDG = [
  {
    characteristic: 'Active Cathodic Protection',
    zinga: 'ZINGA® offers real cathodic (galvanic) protection comparable to HDG. ZINGA® (also called "Zinganisation") shows comparable protection as HDG.',
    other: 'Steel members which have been hot dip galvanized have proven cathodic protection by the sacrificial action of the zinc on its surface.',
  },
  {
    characteristic: 'Easy Application On Site',
    zinga: 'ZINGA® can be applied in the same way as paints, on site or in workshops.',
    other: 'Hot dip galvanization cannot be realized on site. Steel structures must be transported to and from the HDG plant.',
  },
  {
    characteristic: 'Reloadable / Rechargeable',
    zinga: 'A cured ZINGA® layer will reliquefy if a new layer is applied, creating one homogenous layer with continuous electrochemical contact. Light sweep blast or high pressure hot water washing may be used for older layers.',
    other: 'Hot dipped structures can be hot dipped again but will require demounting, blasting and re-dipping. ZINGA® can also re-charge old galvanizing by applying on the rough surface after decontamination.',
  },
  {
    characteristic: 'Overcoatable',
    zinga: 'ZINGA® can be overcoated with a fast drying, compatible paint. Avoid aggressive solvents in the topcoat. Alkyd paints on top of ZINGA® should be avoided.',
    other: 'HDG requires specialized, compatible paints; a thorough surface preparation including alkaline or acid rinsing and sweep blasting is needed before applying a topcoat.',
  },
  {
    characteristic: 'Application in Extreme Conditions',
    zinga: 'ZINGA® can be applied in a wide variety of weather conditions from -15°C to +50°C with a maximum humidity of 95% as long as the dew point is 3°C above the steel temperature.',
    other: 'Not applicable. A HDG layer is applied in the hot dip plant.',
  },
  {
    characteristic: 'Unlimited Shelf Life',
    zinga: 'ZINGA® has unlimited shelf life — always available in storage for touch up or future projects.',
    other: 'Not applicable.',
  },
  {
    characteristic: 'Contact with Potable Water',
    zinga: 'ZINGA® does not contain toxic elements in its dry layer and can be used in contact with potable water. Water saturation with fresh water is recommended 12 hours after application.',
    other: 'Galvanizers approved by the NSF (National Science Foundation) have the authority to galvanize steel for use with potable water.',
  },
];

const VS_METAL = [
  {
    characteristic: 'Active Protection',
    zinga: 'Offers a cathodic protection throughout the layer, comparable to the cathodic protection of hot dip galvanising (Prof. Defrancq - University of Ghent).',
    other: 'Offers a cathodic protection throughout the layer.',
  },
  {
    characteristic: 'Passive Protection',
    zinga: 'A layer of zinc salts slowly builds up on the ZINGA surface, creating a barrier protection. A supplementary barrier protection is also provided by the binder in ZINGA, which reduces the disintegration of the zinc.',
    other: 'The 100% zinc in thermal zinc spray is a naked zinc, without the barrier protection of the zinc particles in ZINGA.',
  },
  {
    characteristic: 'Unique System',
    zinga: 'Does not need a topcoat. A single layer of ZINGA is in itself a duplex system offering ACTIVE-CATHODIC protection and PASSIVE-BARRIER protection.',
    other: 'Has porosities and the zinc in a metallisation layer is a naked zinc — therefore it is necessary to apply a stabilisation coating before applying one or two topcoats.',
  },
  {
    characteristic: 'Flexibility and Brittleness',
    zinga: 'ZINGA containing 96% zinc remains a flexible layer, and resists mechanical shocks by being compressed. No risk of disbonding within a multiple layer of ZINGA. It will never show adhesion failures.',
    other: 'Abrasion and/or impact may result in high incidence chipping and crack propagation due to brittleness of thermal spray coatings, undermining the integrity of the coating surface. Excessive cracking when applied to thin/flexible metal surfaces.',
  },
  {
    characteristic: 'Sharp Corners',
    zinga: 'ZINGA will not break down at sharp corners due to its flexibility.',
    other: 'Thermal spray coatings tend to break down at sharp corners creating target corrosion sites.',
  },
  {
    characteristic: 'Reloading',
    zinga: 'A polymerised ZINGA layer will re-liquidise upon contact with ZINGA, even after 20 years.',
    other: 'After application, the zinc will not re-liquidise upon contact with a new layer.',
  },
  {
    characteristic: 'Surface Preparation',
    zinga: 'ZINGA is applied on a clean and rough surface obtained by blasting Sa 2½, 12.5µm. A complete cleaning to white metal is not required — a certain degree of adhering rust can be accepted.',
    other: 'Thermal Spray requires an extremely clean white blast metal surface. White cleaning is difficult to obtain over large surface areas. Conventional advice is to use Thermal Spray within 30 minutes in open air and 6 hours in covered areas.',
  },
  {
    characteristic: 'Work Force',
    zinga: 'A ZINGA coating can be applied everywhere under normal conditions, regardless of temperature and humidity. It does not require highly qualified personnel.',
    other: 'Thermal Spray coatings are very labour intensive and have to be performed by highly trained technicians in a workshop.',
  },
];

const VS_REBAR = [
  {
    characteristic: 'Corrosion Protection',
    zinga: 'Zinganised Re-bars provide active cathodic (galvanic) protection with 96% zinc in dry film, protecting the steel rebar even when the coating is scratched or damaged.',
    other: 'FBEC (Fusion Bonded Epoxy Coated) re-bars provide only passive barrier protection. Once the epoxy is damaged, corrosion initiates rapidly at the damage site.',
  },
  {
    characteristic: 'Damage Tolerance',
    zinga: 'Zinganised Re-bars tolerate minor damage during handling and placing in concrete without losing corrosion protection, due to the sacrificial nature of zinc.',
    other: 'Any damage to the epoxy coating during transport, handling or placing in formwork creates a point of attack. Even small holidays in the coating can cause severe corrosion.',
  },
  {
    characteristic: 'Bonding with Concrete',
    zinga: 'Zinganised Re-bars have excellent bonding with concrete. Zinc reacts with the alkaline concrete to form calcium hydroxide, which does not affect bond strength.',
    other: 'Epoxy-coated re-bars have reduced bond strength with concrete compared to bare steel, requiring increased development lengths in structural design.',
  },
  {
    characteristic: 'Chloride Resistance',
    zinga: 'Zinc provides both active and passive protection against chloride-induced corrosion, making Zinganised Re-bars ideal for marine and coastal environments.',
    other: 'FBEC provides a barrier against chloride ingress, but once chlorides penetrate any defect in the epoxy, corrosion proceeds rapidly with no self-healing mechanism.',
  },
  {
    characteristic: 'Life Cycle Cost',
    zinga: 'Lower life cycle cost due to longer protection life, ease of field repair, and the ability to recharge the coating if needed.',
    other: 'Higher life cycle cost due to the need for additional structural design provisions, special handling and the catastrophic nature of coating failure.',
  },
];

const CompareTable = ({ rows, vsLabel }) => (
  <div className="adv-table-wrap">
    <table className="adv-table">
      <thead>
        <tr>
          <th className="col-char">Characteristics</th>
          <th className="col-zinga">ZINGA®</th>
          <th className="col-other">{vsLabel}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            <td className="char-cell">{row.characteristic}</td>
            <td className="zinga-cell">{row.zinga}</td>
            <td className="other-cell">{row.other}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const Advantages = () => {
  const [activeTab, setActiveTab] = useState('advantages');

  return (
    <div className="adv-page">
      {/* Hero */}
      <div className="adv-hero">
        <div className="adv-hero-inner">
          <span className="adv-eyebrow">Performance Comparison</span>
          <h1 className="adv-hero-title">Advantages of ZINGA®</h1>
          <p className="adv-hero-sub">
            Discover why ZINGA® is the world leader in cold galvanising — compare it against conventional paint systems, hot dip galvanising, metallizing and more.
          </p>
        </div>
      </div>

      {/* Submenu */}
      <div className="adv-submenu-bar">
        <div className="adv-submenu-inner">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`adv-tab-btn${activeTab === tab.id ? ' active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="adv-content">

        {/* ── Advantages of Zinga ── */}
        {activeTab === 'advantages' && (
          <div className="adv-section">
            <div className="adv-container">
              <div className="adv-chars-box">
                <h2 className="adv-section-title">Characteristics</h2>
                <ul className="adv-char-list">
                  <li>Once thoroughly mixed, ZINGA can be applied by using a normal paintbrush, a short-fibre roller, or a conventional or airless spray-gun.</li>
                  <li>ZINGA can be applied in a wide variety of weather conditions. Application surface temperature range is from <strong>-15°C to +40°C</strong> with a maximum humidity of 95%, as long as the dew point is 3°C minimum above the steel temperature.</li>
                  <li>Working under ambient temperatures ensures no deformation of the steel structure (which can happen in the hot dip galvanization process) and no energy loss.</li>
                </ul>
              </div>

              <h2 className="adv-section-title" style={{ marginTop: '48px' }}>Unique Characteristics &amp; Advantages of ZINGA</h2>

              <div className="adv-grid">
                {ADVANTAGES.map((item) => (
                  <div className="adv-card" key={item.num}>
                    <div className="adv-card-num">{item.num}</div>
                    <div className="adv-card-body">
                      <h3 className="adv-card-title">{item.title}</h3>
                      <p className="adv-card-text">{item.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ── Zinga VS Paint ── */}
        {activeTab === 'vs-paint' && (
          <div className="adv-section">
            <div className="adv-container">
              <h2 className="adv-section-title">Zinga versus Paint</h2>
              <p className="adv-section-lead">ZINGA® distinguished from conventional paint products — not by its application method, but by its superior protective properties.</p>
              <CompareTable rows={VS_PAINT} vsLabel="Paints" />
            </div>
          </div>
        )}

        {/* ── Zinga VS HDG ── */}
        {activeTab === 'vs-hdg' && (
          <div className="adv-section">
            <div className="adv-container">
              <h2 className="adv-section-title">Zinga versus Hot Dip Galvanization</h2>
              <p className="adv-section-lead">ZINGA® offers comparable protection to Hot Dip Galvanizing (HDG) — but with the freedom of on-site application, unlimited rechargeability and no structural distortion.</p>
              <CompareTable rows={VS_HDG} vsLabel="Hot Dip Galvanizing" />
            </div>
          </div>
        )}

        {/* ── Zinga VS Metallizing ── */}
        {activeTab === 'vs-metal' && (
          <div className="adv-section">
            <div className="adv-container">
              <h2 className="adv-section-title">Zinga versus Metallizing</h2>
              <p className="adv-section-lead">ZINGA® provides a unique duplex protection system in a single layer — removing the need for stabilisation coatings required by thermal spray metallizing.</p>
              <CompareTable rows={VS_METAL} vsLabel="Metallisation" />
            </div>
          </div>
        )}

        {/* ── Re-bars VS FBEC ── */}
        {activeTab === 'vs-rebar' && (
          <div className="adv-section">
            <div className="adv-container">
              <h2 className="adv-section-title">Zinganised Re-bars vs Fusion Bonded Epoxy Coated Re-bars</h2>
              <p className="adv-section-lead">In reinforced concrete structures, Zinganised Re-bars outperform Fusion Bonded Epoxy Coated (FBEC) Re-bars in damage tolerance, bond strength and long-term corrosion protection.</p>
              <CompareTable rows={VS_REBAR} vsLabel="Fusion Bonded Epoxy Coated (FBEC)" />
            </div>
          </div>
        )}

      </div>

      {/* CTA */}
      <div className="adv-cta">
        <div className="adv-container">
          <h2>Ready to Switch to ZINGA®?</h2>
          <p>Contact us for technical queries, product samples or bulk orders.</p>
          <a href="/contact" className="adv-cta-btn">Contact Us</a>
        </div>
      </div>
    </div>
  );
};

export default Advantages;
